import config from 'config/config';
import { Maybe, SegmentProps } from 'types/generatedSchemaTypes';

const findSegmentTitle = (
  segments: Maybe<SegmentProps>[],
  segmentUid: Maybe<string> | undefined
) =>
  segments.find((segment) => segment?.uid === (segmentUid || 'Standard'))
    ?.title ?? undefined;

export const resolveSegmentTitle = (
  localizedSegments: Maybe<SegmentProps>[],
  segmentUid: Maybe<string> | undefined
) => findSegmentTitle(localizedSegments, segmentUid) ?? segmentUid;

export const findDefaultTariff = (segments: Maybe<SegmentProps>[]) => {
  return (
    segments &&
    (segments.find((item) => item?.uid === 'Standard') || segments[0])
  );
};

export const isSegmentLocked = (
  segment: Maybe<SegmentProps>,
  unlockingValid: boolean
) => {
  return segment && segment.accessType === 'LOCKED' && !unlockingValid;
};

export const selectedTariffAvailable = (
  selectedTariff?: string,
  segments?: Maybe<SegmentProps>[]
) => {
  return (
    !!selectedTariff &&
    segments &&
    segments.some((pricingSegment) => pricingSegment?.uid === selectedTariff)
  );
};

export const unlockUrlTariffProviders = (url: string | undefined) => {
  if (!url) {
    return null;
  }
  if (
    url.includes('weblogin') &&
    url.includes('.uu') &&
    url.includes('profile')
  ) {
    // URL contains stuff that are for Uppsala University weblogin
    const service = config.VITE_UPPSALA_SERVICE ?? '';
    return {
      provider: 'uppsala',
      service,
      loginUrl: `${url}/login?service=${encodeURI(service)}`,
      logoutUrl: `${url}/logout`,
      responseCheck: '?ticket=',
    };
  }
};

export const segmentsChanged = (
  selectedTariff: string,
  segments: Maybe<SegmentProps>[],
  hasManuallySelectedTariff = false
) => {
  const selectedButNotAvailable = !selectedTariffAvailable(
    selectedTariff,
    segments
  );
  // Only force a private pre-selection while the user hasn't manually chosen.
  // Otherwise a manual non-private choice would be overwritten whenever the
  // pre-selection effect re-runs (e.g. navigating to the scroll wheel view).
  const privateAvailable =
    !hasManuallySelectedTariff &&
    privateSegmentAvailable(selectedTariff, segments);

  return selectedButNotAvailable || privateAvailable;
};

export const privateSegmentAvailable = (
  selectedTariff: string,
  segments: Maybe<SegmentProps>[]
) => {
  const privateSegments = segments?.filter(
    (segment) => segment?.accessType === 'PRIVATE'
  );
  return (
    privateSegments?.length > 0 &&
    !privateSegments?.some((segment) => segment?.uid === selectedTariff)
  );
};
